import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  firstValueFrom,
} from 'rxjs';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DpTableComponent } from '../common-component/dp-table/dp-table.component';
import { DpLoaderComponent } from '../common-component/dp-loader/dp-loader.component';
import { LoaderComponent } from '../common-component/loader/loader.component';
import { ManageUserService } from '../services/raintree/Transmission/manage-user.service';
import { CommonUtilService } from '../services/common-util/common-util.service';
import { AppConfigService } from '../services/config/app-config.service';
import { DistrictListService } from '../services/raintree/Transmission/district-list.service';
import { SatesListService } from '../services/raintree/Transmission/sates-list.service';
import { FilterDialogComponent } from '../views/common/manage-user/manage-user-filter-dialog/manage-user-filter-dialog.component';
import { Dp10FetchAddressService } from '../services/raintree/Transmission/dp1.0-fetch-address.service';
import { Dp10CellComponent } from '../table-cell/dp-10-table-cell.component';
import { Dp10AssignPopupComponent } from './dp1.0-assign-popup/dp1.0-assign-popup.component';
import { Dp10FilterComponent } from './dp1.0-filter/dp1.0-filter.component';

interface User {
  memKey: number;
  permanent_address: string;
  permState: string,
  permDistrict: string,
  isDisable: boolean;
}

@Component({
  selector: 'app-dp1.0',
  standalone: true,
  imports: [
    MatIconModule,
    MatDividerModule,
    CommonModule,
    DpTableComponent,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    DpLoaderComponent,
    LoaderComponent,
    InfiniteScrollModule,
  ],

  templateUrl: './dp1.0.component.html',
  styleUrl: './dp1.0.component.scss',
})
export class Dp10Component implements OnInit {
  @ViewChild('tableScroll') tableScroll!: ElementRef;
  public placeholder: string = 'Search by username/email address';
  isMobileView: boolean = false;
  datatable: any = [];
  filterDataTable: any = [];
  tempData: any = [];
  states: any = [];
  districts: { [key: string]: any[] } = {};
  tempDistricts: { [key: string]: any[] } = {};
  selectedState: string = '';
  selectedDistrict: string = '';
  permissions: any;
  toggleFilter: boolean = false;
  locationAccess: any;
  isLoader: boolean = false;
  seamerTable: any = [];
  numberOfLoaders: number = 20;
  isSuperUser: boolean = false;
  isLoading: boolean = false;
  pageNo: number = 1;
  isScrollable: boolean = true;
  searchTerm = new FormControl<string>('');
  stateAttribute: string = '';
  districtAttribute: string = '';
  levels: string[] = ['ALL LEVEL'];
  selectedLevel: string = 'ALL LEVEL';
  USER_COUNTRY: string = "";
  ADDRESS_ATTRIBUTE: any;
  paramsObj: any;
  filter: any = {}

  constructor(
    public dialog: MatDialog,
    private _manageUserService: ManageUserService,
    private isMobile: CommonUtilService,
    private _appConfig: AppConfigService,
    public districtTransmissionService: DistrictListService,
    public stateTransmissionService: SatesListService,
    public stateListService: SatesListService,
    public districtListService: DistrictListService,
    public _dp1_0_fetch_data: Dp10FetchAddressService
  ) {
    this.seamerTable = [];
  }

  public displayColumnData: any = [];
  // searchTerm: string = '';
  async ngOnInit() {
    this.isMobileView = this.isMobile.isMobileDevice();
    this.USER_COUNTRY = Object.keys(this._appConfig.fetchPermissionv3ByViewName())![0];
    this.ADDRESS_ATTRIBUTE = await firstValueFrom(this._dp1_0_fetch_data.fetchAddressAttribute({ uiCountry: this.USER_COUNTRY }));
    console.log(this.ADDRESS_ATTRIBUTE)
    this.stateAttribute = this.ADDRESS_ATTRIBUTE.data[0].stateAttributeName;
    this.stateAttribute = this.stateAttribute.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    this.districtAttribute = this.ADDRESS_ATTRIBUTE.data[0].districtAttributeName;
    this.districtAttribute = this.districtAttribute.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());

    this.displayColumnData = [
      {
        id: 'address',
        name: 'Address',
      },
      {
        id: 'state',
        name: `${this.stateAttribute}`
      }, {
        id: 'district',
        name: `${this.districtAttribute}`
      },
      {
        id: 'assign',
        name: '',
        width: '250px',
      },
    ];
    this.filter = { country: this.USER_COUNTRY }
    this.fetchUsers();


  }

  onClickFilter() {
    const filterDialogRef = this.dialog.open(Dp10FilterComponent, {
      data: this.filter
      //maxWidth: '600px'
    })

    filterDialogRef.afterClosed().subscribe((response: any) => {
      this.filter = { ...this.filter, ...response };
      this.paramsObj = { ...response };
      this.pageNo = 1
      this.filterDataTable = [];
      this.datatable = [];
      this.tempData = [];
      this.fetchUsers();
    })
  }

  onScroll(event: any): void {
    if (this.isScrollable) {
      this.isLoading = true;
      this.pageNo++;
      this.fetchUsers(false);
    }
  }

  openFilterDialog(): void {
    this.dialog.open(FilterDialogComponent);
  }


  cellComponentMap = {
    assign: Dp10CellComponent,
  };

  onScrollTable() {
    console.log('scrolled');
    if (this.isScrollable) {
      this.pageNo++;
      this.fetchUsers(false);
    }
  }
  fetchUsers(isStart?: boolean): void {
    this.isLoading = true;
    this.paramsObj = {
      ...this.paramsObj,
      uiCountry: this.USER_COUNTRY,
    };

    this._dp1_0_fetch_data.fetchDP1_0_Data(this.paramsObj).subscribe({
      next: (response: any) => {
        console.log(response.data);
        if (response.data.length === 0) {
          this.isScrollable = false;
        }

        this.isLoading = false;
        this.filterDataTable = this.datatable = response.data.map((item: User) => ({
          memKey: item.memKey,
          address: item.permanent_address,
          state: item.permState,
          district: item.permDistrict,
          isDisabled: false,
        }));
        this.isLoader = false;
        this.isLoading = false;

        setTimeout(() => {
          this.tableScroll?.nativeElement.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        });

      },
      error: (error) => {
        this.isLoader = false;
      },
    });
  }

  openDialog(rowData: any) {
    console.log('row', rowData);
    const dialogRef = this.dialog.open(Dp10AssignPopupComponent, {
      data: {
        userDetails: rowData,
        userCountry: this.USER_COUNTRY,
        address_attribute: this.ADDRESS_ATTRIBUTE.data[0]
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 1) {
        rowData.isDisabled = true;
      }
    });
  }

  openDialogMobile(rowData: any) {
    // if(!this.isMobileView){
    console.log(rowData);

    const dialogRef = this.dialog.open(Dp10AssignPopupComponent, {
      data: {
        userDetails: rowData,
        userCountry: this.USER_COUNTRY,
        address_attribute: this.ADDRESS_ATTRIBUTE.data[0]
      },
      //width: '50vw'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 1) {
        rowData.isDisabled = true;
      }
    });
  }

  onInputChange(event: any) {
    const inp: string = event.target.value;
    this.filterDataTable = this.datatable.filter((item: any) => JSON.stringify(item).toLowerCase().includes(inp))
  }

  toggleFilterOptions() {
    this.toggleFilter = !this.toggleFilter;
  }

  onStateChange() {
    // this.fetchDistricts(this.selectedState);
    if (
      this.districts[this.selectedDistrict] ||
      this.districts[this.selectedState].length == 0
    ) {
      this.districts[this.selectedDistrict] = [];
      // this.getDistrictList(this.selectedState);
    }
    this.selectedDistrict = '';
    this.fetchUsers(false);
  }
  clearStateSelection() {
    this.selectedState = '';
    this.selectedDistrict = '';
    this.fetchUsers(false);
  }
  clearDistrictSelection() {
    this.selectedDistrict = '';
    this.fetchUsers(false);
  }
  fetchDistrict(state: string) { }
  getDistrictList(state: any) {
    if (!this.locationAccess.states) {
      this.districtListService.getDistrictList(state).subscribe({
        next: (response: any) => {
          if (!response.error) {
            let resp = response.data;
            this.districts[state] = [];
            //////////////////////////left at here the work is remaining
            resp.forEach((item: any) => {
              this.districts[state].push(item.district_name);
            });
          }
        },
        error: (error) => { },
      });
    }
  }
  onDistrictChange() {
    this.fetchUsers(false);
  }

  loadPermissionLevels() {
    this._manageUserService.fetchManagablePermissionLevels().subscribe({
      next: (response: any) => {
        if (response.data) {
          this.levels.push(...response.data);
        }
      },
      error: (error: any) => {
        this.isLoading = false;
      },
    });
  }

  onLevelChange() {
    this.fetchUsers(false);
  }
}
